module.exports = __webpack_public_path__ + "static/media/delete_icon.db6ff66e.svg";